declare global {
  interface Window {
    _env_: any;
  }
}

export const constants = {
  API: window?._env_.API_URL,
  ENV: window?._env_.ENV,
  CART_ITEMS_KEY: 'CART_ITEMS',
  USER_TOKEN_KEY: 'USER_TOKEN',
  USER_ID_KEY: 'USER_ID',
  USER_SHOPPER_ID_KEY: 'USER_SHOPPER_ID',
  USER_PHONE_KEY: 'USER_PHONE',
  USER_ADDR_L1: 'USER_ADDR_L1',
  USER_ADDR_L2: 'USER_ADDR_L2',
  USER_ADDR_CITY: 'USER_ADDR_CITY',
  USER_ADDR_PROVINCE: 'USER_ADDR_PROVINCE',
  USER_ADDR_LOCALITY: 'USER_ADDR_LOCALITY',
  USER_NAME: 'USER_NAME',
};
